import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { post } from "../../utils/apiManager";
import { toast } from "react-toastify";
import { baseURL } from "../../config/config";

const inputStyle = (hasError) => ({
  width: '100%', padding: '10px 14px', borderRadius: 8,
  border: `1.5px solid ${hasError ? '#AD2429' : '#e2e8f0'}`,
  fontSize: 14, color: '#0a1628', background: '#fff',
  outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit',
});

const Add = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const Navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onSubmit = (data) => {
    setLoading(true);
    post(`${baseURL}/plan-feature/create`, { name: data.name, description: data.description })
      .then((res) => { setLoading(false); if (res?.status) Navigate("/admin/plan-features"); else toast.error(res?.message); })
      .catch((err) => { setLoading(false); toast.error(err?.response?.data?.error); });
  };

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #edf0f7', boxShadow: '0 1px 4px rgba(26,39,68,.05)', overflow: 'hidden', maxWidth: 680 }}>
        <div style={{ padding: '18px 28px', borderBottom: '1px solid #edf0f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>Add Plan Feature</h3>
            <p style={{ fontSize: 13, color: '#9aa5c0', margin: '3px 0 0' }}>Create a new feature for pricing plans</p>
          </div>
          <button onClick={() => Navigate('/admin/plan-features')} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>← Back</button>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} style={{ padding: '28px' }}>
          <div style={{ marginBottom: 20 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'flex', gap: 4 }}>
              Feature Name <span style={{ color: '#AD2429' }}>*</span>
            </label>
            <input placeholder="e.g., Unlimited Auctions, Premium Support" type="text" style={inputStyle(errors.name)} {...register("name", { required: true })} />
            {errors.name && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Feature name is required</span>}
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>Description <span style={{ color: '#9aa5c0', fontWeight: 400 }}>(optional)</span></label>
            <textarea placeholder="Brief description of this feature..." rows={3} style={{ ...inputStyle(false), resize: 'vertical' }} {...register("description")} />
          </div>
          <div style={{ paddingTop: 16, borderTop: '1px solid #edf0f7', display: 'flex', gap: 12 }}>
            <button type="submit" disabled={loading} style={{ background: '#AD2429', color: '#fff', border: 'none', borderRadius: 8, padding: '11px 28px', fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit', opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Saving...' : 'Save Feature'}
            </button>
            <button type="button" onClick={() => Navigate('/admin/plan-features')} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '11px 22px', fontSize: 15, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Add;
